<i18n>
{
  "ru":{
    "invoice_details": "Детали счета"
  },
  "en":{
    "invoice_details": "Invoice details"
  }
}
</i18n>
<template>
  <el-dialog :close-on-click-modal="false" custom-class="webpay" :visible.sync="visibleInner" top="1vh">
    <span slot="title">
      <h4></h4>
    </span>
    <invoice-details :visible.sync="visibleInner" :url="url" :showRemoveButton="false" :callback="callback"></invoice-details>
  </el-dialog>
</template>

<script>
import InvoiceDetails from './InvoiceDetails'

export default {
  name: 'invoice-details-modal',
  props: ['visible', 'url', 'callback'],
  components: {
    'invoice-details': InvoiceDetails
  },
  computed: {
    visibleInner: {
      get () {
        return this.visible
      },
      set (val) {
        if (!val) {
          this.$emit('update:visible', false)
        }
      }
    }
  }
}
</script>
